import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/world.svg
 */
const IconWorld: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12 24c1.816 0 3.728-2.91 4.51-7.568H7.52C8.272 21.091 10.185 24 12 24zM12 0c-1.815 0-3.728 2.907-4.51 7.566h8.99C15.728 2.907 13.816 0 12 0zM16.657 8.827H7.32a29.062 29.062 0 000 6.34h9.336a29.057 29.057 0 000-6.34zM9.162.219a11.984 11.984 0 00-5.05 2.65 12.148 12.148 0 00-3.28 4.697H6.25A14.837 14.837 0 019.162.22zM9.162 23.78a14.837 14.837 0 01-2.912-7.348H.831a12.154 12.154 0 003.28 4.7 11.981 11.981 0 005.051 2.647zM5.912 11.997c0-1.059.056-2.117.17-3.17H.416a12.247 12.247 0 000 6.34h5.664a29.59 29.59 0 01-.17-3.17zM14.838.219a14.83 14.83 0 012.914 7.347h5.419a12.149 12.149 0 00-3.28-4.698 11.987 11.987 0 00-5.053-2.65zM14.838 23.78a11.984 11.984 0 005.052-2.648 12.155 12.155 0 003.28-4.7h-5.419a14.83 14.83 0 01-2.913 7.347zM18.088 11.997c0 1.06-.056 2.118-.169 3.17h5.664a12.27 12.27 0 000-6.34H17.92c.113 1.053.17 2.111.17 3.17z"
      fill="currentColor"
    />
  </svg>
);

export default IconWorld;
